import React, { useEffect, useState } from 'react'
import Header from './Header';
import ContactForm from './ContactForm';
import RegisterForm from './RegisterForm';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const HomepageBanner = ({ pageName }) => {
    const { t, i18n } = useTranslation();
    const [ios, setIos] = useState(null);
    const [android, setAndroid] = useState(null);

    const getApps = () => {
        const url = (window.location.origin.includes("localhost") || window.location.origin.includes("test")) ? "https://paragon.testmedici.com" : window.location.origin;
        axios.get(`${url}/api/Global/Apps`)
            .then(response => {
                setIos(response.data.ios);
                setAndroid(response.data.android);
            })
            .catch(error => {
                console.error('Hata:', error);
            });
    }

    useEffect(() => {
        getApps();
    }, [])

    const Banner1 = () => (
        <div className='homepage-banner-content'>
            <Header />
            <div className="container">
                <div className="homepage-banner-content-row row">
                    {/* <div className="col-lg-3 banner-content-text first-banner-content">
                        <h5 className='mb-3'>
                            Mastering Your Financial Future
                        </h5>
                        <p className="mb-0">
                            Lorem ipsum dolor sit amet.
                        </p>
                        <div className="mt-4">
                            <button className="btn-primary-v2">Hemen Keşfet</button>
                        </div>
                    </div> */}

                    <div className="col-lg-6 banner-content-text">
                        <h3>
                            {t('Yatırım Fırsatlarını Paragon ile Keşfedin')}
                        </h3>
                        <div className='d-flex align-items-center mt-5 banner-marketplace'>
                            <div className='me-3 mb-lg-0 mb-2'>
                                <a href={ios} target='_blank'>
                                    <img src="https://templatekit.jegtheme.com/digipay/wp-content/uploads/sites/385/2023/06/Mobile-app-store-badge.png" alt="" width="150px" />
                                </a>
                            </div>
                            <div>
                                <a href={android} target='_blank'>
                                    <img src="https://templatekit.jegtheme.com/digipay/wp-content/uploads/sites/385/2023/06/Mobile-play-store-badge.png" alt="" width="170px" />
                                </a>
                            </div>
                        </div>
                    </div>
                    {/* <div className="col-lg-3 banner-content-mockup">
                        <img src="https://templatekit.jegtheme.com/digipay/wp-content/uploads/sites/385/2023/06/digipay-payment-app-ADPM2QY-1.png" alt="" width="250px" />
                    </div> */}
                </div>
            </div>
        </div>
    )

    const Banner2 = () => (
        <div className='homepage-banner-content subpage-banner-content'>
            <Header />
            <div className="container">
                <div className="homepage-banner-content-row row">
                    <div className="col-lg-8 banner-content-text">
                        <h3>
                            {t('Paragon ile Yatırımda Güven ve Başarı')}
                        </h3>
                        <p className='mb-0 mt-4'>
                            {t('Paragon Yatırım, forex piyasasında güvenli işlemler ve yüksek başarı oranları ile yatırımcılarına kazançlı fırsatlar sunar. Uzman ekibimiz ve yenilikçi platformlarımızla finansal hedeflerinize güvenle ulaşın.')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )

    const Banner3 = () => (
        <div className='homepage-banner-content subpage-banner-content'>
            <Header />
            <div className="container">
                <div className="homepage-banner-content-row row">
                    <div className="col-lg-8 banner-content-text">
                        <h3>
                            {t('Yatırımınızı Kolaylaştıran Güçlü Platformlar')}
                        </h3>
                        <p className='mb-0 mt-4'>
                            {t('Paragon Yatırım, kullanıcı dostu ve güvenli işlem platformları ile yatırımcılarına hızlı, verimli ve sorunsuz bir ticaret deneyimi sunar. Yenilikçi araçlar, anlık piyasa verileri ve güçlü analiz seçenekleri ile her seviyeden yatırımcıya hitap eder.')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )

    const Banner4 = () => (
        <div className='homepage-banner-content subpage-banner-content'>
            <Header />
            <div className="container">
                <div className="homepage-banner-content-row row">
                    <div className="col-lg-8 banner-content-text">
                        <h3>
                            {t('Yatırım Fırsatlarınızı Paragon ile Çeşitlendirin')}
                        </h3>
                        <p className='mb-0 mt-4'>
                            {t('Paragon Yatırım, geniş ürün yelpazesi ile yatırımcılarına döviz, emtia, hisse senetleri ve daha birçok alanda kazançlı fırsatlar sunar. Her seviyeden yatırımcı için esnek ve kârlı çözümlerle finansal hedeflerinize ulaşın.')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )

    const Banner5 = () => (
        <div className='homepage-banner-content subpage-banner-content contact-banner-content'>
            <Header />
            <div className="container">
                <div className="homepage-banner-content-row row justify-content-between">
                    <div className="col-lg-6 banner-content-text">
                        <h3>
                            {t('Sizler İçin Buradayız')}
                        </h3>
                        <p className="mb-0 mt-3">
                            {t('Paragon Yatırım ile her zaman kolayca iletişime geçebilirsiniz. Sorularınız, geri bildirimleriniz ya da destek talepleriniz için aşağıdaki iletişim kanallarını kullanabilirsiniz. Profesyonel destek ekibimiz, ihtiyaçlarınıza hızlı ve etkili çözümler sunmak için burada.')}
                        </p>
                        <div className='mt-5'>
                            <div className='d-flex align-items-center'>
                                <div className="icon-container">
                                    <i className="fa-solid fa-envelope fa-lg"></i>
                                </div>
                                <div className='ms-3'>
                                    <h6>{t('E-posta Adresi')}</h6>
                                    <a href='mailto:support@paragonyatirim.com' className="mb-0">support@paragonyatirim.com</a>
                                </div>
                            </div>
                            <div className='d-flex align-items-center mt-4'>
                                <div className="icon-container">
                                    <i className="fa-solid fa-phone fa-lg"></i>
                                </div>
                                <div className='ms-3'>
                                    <h6>{t('Telefon Numarası')}</h6>
                                    <a target='_blank' href='https://wa.me/447413174135' className="mb-0">+447413 174135</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-5 mt-lg-0 mt-5">
                        <ContactForm />
                    </div>
                </div>
            </div>
        </div>
    )

    const Banner6 = () => (
        <div className='homepage-banner-content subpage-banner-content contact-banner-content register-banner-content'>
            <Header />
            <div className="container">
                <div className="homepage-banner-content-row row justify-content-between">
                    <div className="col-xl-6 banner-content-text">
                        <h3>
                            {t('Paragon ile Yatırıma Adım Atın')}
                        </h3>
                        <p className="mb-0 mt-3">
                            {t('Hemen bir hesap oluşturarak forex piyasasında kazançlı fırsatları keşfedin. Güvenli işlem altyapımız ve profesyonel destek ekibimizle, yatırımlarınızı en verimli şekilde yönetebilirsiniz. Adımınızı atın, finansal geleceğinizi Paragon ile şekillendirin!')}
                        </p>
                        <div className='mt-5'>
                            <div className='row align-items-center'>
                                <div className="col-xl-1 col-2">
                                    <div className="icon-container">
                                        <i className="fa-solid fa-envelope fa-lg"></i>
                                    </div>
                                </div>
                                <div className="col-xl-11 col-10">
                                    <div className="ms-3">
                                        <h6>{t('E-posta Adresi')}</h6>
                                        <a href='mailto:support@paragonyatirim.com' style={{ color: "#EEFFFAB8" }} className="mb-0 text-decoration-none">support@paragonyatirim.com</a>
                                    </div>
                                </div>
                            </div>
                            <div className='row align-items-center mt-4'>
                                <div className="col-xl-1 col-2">
                                    <div className="icon-container">
                                        <i className="fa-solid fa-phone fa-lg"></i>
                                    </div>
                                </div>
                                <div className="col-xl-11 col-10">
                                    <div className='ms-3'>
                                        <h6>{t('Telefon Numarası')}</h6>
                                        <a target='_blank' href='https://wa.me/447413174135' style={{ color: "#EEFFFAB8" }} className="mb-0 text-decoration-none">+447413 174135</a>
                                    </div>
                                </div>
                            </div>
                            <div className='row align-items-center mt-4'>
                                <div className="col-xl-1 col-2">
                                    <div className="icon-container">
                                        <i className="fa-solid fa-location-dot fa-lg"></i>
                                    </div>
                                </div>
                                <div className="col-xl-11 col-10">
                                    <div className='ms-3'>
                                        <h6>{t('Adres')}</h6>
                                        <a target='_blank' href='https://maps.app.goo.gl/SdrktzE7xVyq9Zog7' style={{ color: "#EEFFFAB8" }} className="mb-0 text-decoration-none">{t('1 Pall Mall E, London SW1Y 5AU, United Kingdom')}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-5 mt-lg-0 mt-5">
                        <RegisterForm />
                    </div>
                </div>
            </div>
        </div>
    )

    const renderHeader = () => {
        if (pageName === "homepage") {
            return Banner1();
        }
        if (pageName === "about") {
            return Banner2()
        }
        if (pageName === "tradingplatforms") {
            return Banner3()
        }
        if (pageName === "investmentproducts") {
            return Banner4()
        }
        if (pageName === "contact") {
            return Banner5()
        }
        if (pageName === "register") {
            return Banner6()
        }
    }

    return (
        renderHeader()
    )
}

export default HomepageBanner;